import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Label } from '@/components/ui/label';

interface ClientSelectorProps {
  onClientSelect: (clientId: string, clientEmail: string, client: any) => void;
  selectedClientId?: string;
}

export default function ClientSelector({ onClientSelect, selectedClientId }: ClientSelectorProps) {
  const { data: clients, isLoading } = useQuery({
    queryKey: ['clients-for-email'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('clients')
        .select('id, full_name, email, phone, tax_year, filing_status, ssn_last_4')
        .order('full_name', { ascending: true });
      
      if (error) throw error;
      return data;
    },
  });

  const handleSelect = (clientId: string) => {
    const client = clients?.find(c => c.id === clientId);
    if (client) {
      onClientSelect(clientId, client.email, client);
    }
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="client-select">Select Client</Label>
      <Select value={selectedClientId} onValueChange={handleSelect} disabled={isLoading}>
        <SelectTrigger id="client-select">
          <SelectValue placeholder={isLoading ? "Loading clients..." : "Choose a client"} />
        </SelectTrigger>
        <SelectContent>
          {clients?.map((client) => (
            <SelectItem key={client.id} value={client.id}>
              {client.full_name} ({client.email})
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
